import store from '@/redux/store';
import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'

import * as fileUploadConst from "@/actions/constFileUpload";
import FileAPI from '@/api/FileAPI';
import * as constTree from "@/actions/constTree";

export const initialState = {
  files: [],
  filterd: [],
  posts: [],
  selectedFile: null,
  isInProgress: false,
  status: 'idle',
  error: null,
  companystructure: [],
  selectedMap: null,  
};

export const addNewPost = createAsyncThunk(
  'posts/addNewPost',
  // The payload creator receives the partial `{title, content, user}` object
  async (initialPost, event) => {
      const {FileUpload} = event.getState();
    // We send the initial data to the fake API server
	  const response = FileAPI.storeFile( initialPost, FileUpload.selectedMap );
	  return response
  }
)

export const addFileDescription = createAsyncThunk(
  'posts/addFileDescription',
  // The payload creator receives the partial `{title, content, user}` object
  async (initialPost, event) => {
      const {FileUpload} = event.getState();
    // We send the initial data to the fake API server
      const response = FileAPI.addFileDescription( initialPost.fileId, initialPost.description );
      return response
  }
)


export const fetchPosts = createAsyncThunk('posts/fetchPosts', async () => {
  const response = FileAPI.getFiles();
  return response
})

export const downloadFile = createAsyncThunk('files/downloadFile', async () => {
  const response = FileAPI.downloadFile();
  return response
})

export const deleteFile = createAsyncThunk('files/deleteFile', async (file) => {
  const response = FileAPI.deleteFile(file);
  return response
})

const filterOnFile=(state) => {
    state.filterd = state.posts.filter(file => file.mapkey == state.selectedMap);
    return state.filterd;
        
}

const postsSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
      setMapId(state, action) {
          if(action.type == "posts/setMapId") {
            state.selectedMap = action.payload.mapId

            filterOnFile(state);
        }
    }
    // omit existing reducers here
  },
  extraReducers(builder) {
    builder
      .addCase(addFileDescription.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(addFileDescription.fulfilled, (state, action) => {
        state.status = 'succeeded'
        // Add any fetched posts to the array
        state.status = 'succeeded';
        //state.posts = state.posts.concat(action.payload.data.data.data);
        //state.companystructure = action.payload.data.data.companystructure;
      })
      .addCase(addFileDescription.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      
      
    builder
      .addCase(fetchPosts.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.status = 'succeeded'
        // Add any fetched posts to the array
        state.posts = state.posts.concat(action.payload.data.data.data);
        filterOnFile(state);
        state.companystructure = action.payload.data.data.companystructure;
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })

     builder.addCase(addNewPost.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
      state.posts.push(action.payload.data.data.data);
      filterOnFile(state);
      state.selectedFile = action.payload.data.data.data;
    })
    
     builder.addCase(downloadFile.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
    })      

     builder.addCase(deleteFile.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
      state.posts = [];
      state.posts = state.posts.concat(action.payload.data.data.data);
      filterOnFile(state);
    })      

          
  }
})

export const selectAllPosts = state => state.FileUpload.filterd

export const { setMapId, postAdded, postUpdated, reactionAdded } = postsSlice.actions

export default postsSlice.reducer